export function calculateFirstAttemptAccuracy (activity) {
  let topicAccuracyAvg = 0

  if (activity.finalScore &&
    activity.finalScore.activityScore >= activity.finalScore.scoreTarget) {
    topicAccuracyAvg = getQuestionAccuracy(activity.finalScore.topics)
  } else {
    topicAccuracyAvg = getQuestionAccuracy(activity.topics)
  }

  return topicAccuracyAvg
}

export function calculateRetakeAccuracy (activity) {
  let topicAccuracyAvg = 0

  if (activity.finalScore &&
    activity.finalScore.activityScore >= activity.finalScore.scoreTarget &&
    activity.score.activityScore >= activity.score.scoreTarget) {
    topicAccuracyAvg = getQuestionAccuracy(activity.topics)
  } else {
    return false
  }

  return topicAccuracyAvg
}

export function getQuestionAccuracy (activityTopics) {
  let totalPointsEarned = 0
  let totalPointsAvailable = 0

  if (activityTopics) {
    activityTopics.forEach(function (topic) {
      totalPointsEarned += topic.totalPointsEarned
      totalPointsAvailable += topic.totalPointsAvailable
    })
  }

  return totalPointsAvailable > 0 && totalPointsEarned > 0
    ? Math.round(100 * totalPointsEarned / totalPointsAvailable)
    : 0
}
